import { gsap } from "gsap";
import { addWindowPadding, clearWindowPadding } from "../scrollbar-padding.js";

function openModal(modal, form) {
  //   document.dispatchEvent(
  //     new CustomEvent("opening-modal", { detail: modal.getAttribute("id") }),
  //   );

  if (modal) {
    gsap.set(modal, { scale: 0.9, opacity: 0, display: "block" });

    let tl = gsap.timeline({
      onComplete: () => {
        modal.classList.add("is-open");
        gsap.set([modal], { clearProps: "all" }); // Clear all inline styles after animation
        // document.dispatchEvent(
        //   new CustomEvent("opened-modal", { detail: modal.getAttribute("id") }),
        // );
      },
    });

    tl.to(modal, { scale: 1, opacity: 1, duration: 0.3, ease: "power2.inOut" });
  } else {
    console.error("Modal form or sections not found");
  }

  /* Handle the navigation state if form has been launched from open menu */
  if (!document.querySelector(".js-off-canvas-nav.is-open")) {
    document.querySelector("body").classList.add("nav-open");
    addWindowPadding();
  }
  // Allow close button to be accessed by making top bar shorter
  document.querySelector("body").classList.add("modal-open");
}

function closeModal(e) {
  e.preventDefault();

  const closeElem = e.currentTarget;
  const modal = closeElem.closest(".modal-overlay");
  const form = modal.querySelector("form");

  console.log(modal);

  if (!closeElem.hasAttribute("aria-disabled")) {
    closeElem.setAttribute("aria-disabled", "true");

    if (modal) {
      console.log("something 1");
      let tl = gsap.timeline({
        onComplete: () => {
          modal.classList.remove("is-open");
          gsap.set([modal], { clearProps: "all" }); // Clear all inline styles after animation
          console.log("something 1");
          document.querySelector("body").classList.remove("nav-open");

          document.querySelector("body").classList.remove("modal-open");

          modal
            .querySelectorAll(".js-close-modal-overlay")
            .forEach((closeElem) => {
              closeElem.removeAttribute("aria-disabled");
              closeElem.removeEventListener("click", closeModal);
            });

          document
            .querySelectorAll(
              '[aria-controls="' + modal.getAttribute("id") + '"]',
            )
            .forEach((openCtrl) => {
              console.log(openCtrl);
              openCtrl.setAttribute("aria-expanded", "false");
              openCtrl.removeAttribute("aria-disabled");
            });
          //   document.dispatchEvent(
          //     new CustomEvent("closed-modal", {
          //       detail: modal.getAttribute("id"),
          //     }),
          //   );
        },
      });

      tl.to(modal, {
        scale: 0.9,
        opacity: 0,
        duration: 0.25,
        ease: "power2.inOut",
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const controls = document.querySelectorAll(".js-toggle-modal-form");

  controls.forEach((openControl) => {
    openControl.addEventListener("click", (e) => {
      e.preventDefault();

      if (!openControl.hasAttribute("aria-disabled")) {
        const modalTarget = openControl.getAttribute("aria-controls");
        const modal = document.querySelector(`#${modalTarget}`);
        if (modal) {
          const form = modal.querySelector("form");

          const closeControls = modal.querySelectorAll(
            ".js-close-modal-overlay",
          );
          if (closeControls.length > 0) {
            openControl.setAttribute("aria-expanded", "true");
            openControl.setAttribute("aria-disabled", "true");

            openModal(modal, form);
            closeControls.forEach((closeElem) => {
              closeElem.addEventListener("click", closeModal);
            });
          }
        }
      }
    });
  });
});
jQuery(document).ready(function ($) {
  $(document).on("gform_confirmation_loaded", function (event, formId) {
    if(formId == 4){
      const confirmationWrap =  $('.contact-form-confirmation');
      const formWrap =  $('.contact-form-wrapper');

      formWrap.fadeOut();
      confirmationWrap.fadeIn();
    }
    
  });
});
